import React from 'react';
import * as S from './style';
import { Label, Row } from 'components';
import Input, { Props as InputProps } from 'components/atoms/Input';
import InputOnlyNumber from 'components/atoms/InputOnlyNumber';

type InputType = 'NUMBER';

export interface Props {
  inputProps: InputProps;
  inputType?: InputType;
  label?: string;
  caption?: React.ReactNode | null;
  maxLength?: number;
  onChangeHandler?: (type: any, value: string) => void;
  rowContainerStyle?: React.CSSProperties;
}

function FormInput({
  inputProps,
  inputType,
  caption,
  rowContainerStyle,
  ...props
}: Props): React.ReactElement {
  return (
    <Row rowContainerStyle={rowContainerStyle}>
      <S.FormItemContainer>
        <Label
          contents={props.label}
          fontStyle={'caption'}
          color={'gray_opacity_800'}
        />
        <S.InputWrapper>
          {inputType === 'NUMBER' ? (
            <InputOnlyNumber
              {...inputProps}
              maxLength={props.maxLength}
              onChangeHandler={props.onChangeHandler}
            />
          ) : (
            <Input {...inputProps} />
          )}
        </S.InputWrapper>
        {caption ? <S.CaptionWrapper>{caption}</S.CaptionWrapper> : null}
      </S.FormItemContainer>
    </Row>
  );
}

export default FormInput;
